import React from 'react'
import { FieldType } from '../context'
import { MinimalTiptapEditor } from '@/components/ui/minimal-tiptap'
import { cn } from '@/lib/utils'

type Props = {
    field: FieldType
    className?: string;
}

const QuestionRenderer = ({ field, className }: Props) => {
    if(typeof field.question === 'string') {
        return (    
            <div className={cn('flex items-center gap-2', className)}>
                <p className="whitespace-pre-line">{field.question}</p>
                {field.required && <span className="text-red-600">*</span>}
            </div>
        )
    } 
    else {
        return (
            <MinimalTiptapEditor 
                value={field.question}
                hideToolbar
                editable={false}
                mode='read'
                className='p-0 border-none shadow-none'
                editorClassName='p-0 border-none shadow-none'
            />
        )
    }

}

export default QuestionRenderer